/**
 * Created by slava on 24.03.17.
 */

// eslint-disable-next-line
let VictoryWindow = CleverappsWindow.extend({
    ctor: function (victoryRewards) {
        this.game = Game.currentGame;
        this.boatswain = this.game.boatswain;
        this.next = undefined;
        this.victoryRewards = victoryRewards;

        this._super();
    },

    onWindowLoaded: function () {
        const styles = cleverapps.styles.VictoryWindow;

        this.rumble = cleverapps.isRumble() && cleverapps.knockoutGame.rumble;
        if (this.rumble) {
            this.rumbleRound = this.rumble.getPrevRound();

            if (!this.rumbleRound) {
                cleverapps.throwAsync(`can't find round for rumble [${this.rumble.rounds.map((round) => round.players && round.players.join(",")).join("],[")}]`);
            }
        }

        this.content = new cleverapps.Layout(this.listComponents(), {
            direction: cleverapps.UI.VERTICAL,
            padding: styles.padding,
            margin: styles.margin
        });

        this._super({
            name: "victorywindow",
            title: this.getTitleText(),
            shareId: !this.rumble && !cleverapps.instantTournament.isInTournament() && "victory",
            styles,
            content: this.content,
            fireworks: !cleverapps.isKnockoutGame() && this.game.outcome === GameBase.OUTCOME_VICTORY,
            noBackground: true,
            closeButtonManual: true
        });

        if (this.boatswain) {
            this.boatswain.setIntent(Boatswain.RETURN_INTENT);
        }
    },

    onClose: function () {
        this.victoryRewards.replaceParentSamePlace(cleverapps.Scenes.GetRunningScene());
    },

    onShow: function () {
        this._super();

        const styles = cleverapps.styles.VictoryWindow;

        this.runAction(new cc.Sequence(
            new cc.DelayTime(styles.soundDelay || 0),
            cleverapps.effects.fireAction("victory.window.show")
        ));

        this.victoryRewards.showUp(this.delayedShowUp.bind(this));
        this.content.children.forEach((component) => {
            if (component.showUp && component !== this.victoryRewards) {
                component.showUp();
            }
        });
    },

    getPerson: function () {
        return {
            role: "hero",
            emotion: "happy"
        };
    },

    getTitleText: function () {
        if (this.rumble) {
            return this.rumbleRound && this.rumbleRound.isLast()
                ? Messages.get("KnockoutWindow.Title.Final")
                : Messages.get("KnockoutWindow.Title.Round", { roundId: (this.rumbleRound && this.rumbleRound.id || 0) + 1 });
        }

        if (this.game.outcome === GameBase.OUTCOME_LOST) {
            return Messages.get("LoseWindow.title");
        }

        if (Game.currentGame.getMode() === GameBase.MODE_HIGHSCORE) {
            return false;
        }

        return Messages.get("VictoryWindow.Victory");
    },

    listComponents: function () {
        const data = [];

        if (cleverapps.config.type === "battlefield") {
            data.push(new BattleStatsComponent());
        }

        if (Game.currentGame.getMode() === GameBase.MODE_HIGHSCORE) {
            data.push(new ScoreComponent());
        }

        if (this.game.level.isHard() && bundles.victory_window.jsons.hard_animation_json) {
            data.push(new PictureComponent(this.game.level));
        }

        data.push(this.victoryRewards);

        if (this.rumbleRound) {
            data.push(new RoundResultsComponent(this.rumbleRound, { victory: true }));
            data.push(new RoundCountdownComponent(() => {
                if (!this.closed) {
                    this.close();
                }
            }));
        }

        return data;
    },

    getPreferredBundles: function () {
        return ["game"];
    },

    listBundles: function () {
        return ["victory_window"].concat(this.victoryRewards.rewards.listBundles());
    }
});

cleverapps.styles.VictoryWindow = {
    margin: 40,
    padding: {
        top: 60,
        bottom: 100
    },

    windowShowUpAnimation: undefined,

    rewards: {
        textMargin: 0,

        iconWrap: {
            width: 130,
            height: 130
        },

        margin: 30,

        padding: {
            x: 0,
            y: 0
        }
    }
};
